import React from "react";
import { Box, Container, Typography, Grid2, Paper } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import BookIcon from "@mui/icons-material/Book";

const About: React.FC = () => {
  return (
    <Box
      id="section-overview"
      sx={{ py: 10, position: "relative", overflow: "hidden" }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          width: { sm: "50%", md: "25%", lg: "25%" }, // Adjust width as needed
          backgroundImage: "url(/images/profile.jpg)", // Replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
        }}
      />
      <Container>
        <Grid2 container spacing={4} justifyContent="flex-end">
          <Grid2 size={{ xs: 12, sm: 6, md: 8 }}>
            <Box sx={{ pr: { md: 4 } }}>
              <Typography
                variant="h2"
                gutterBottom
                sx={{ textAlign: { xs: "center", md: "left" } }}
              >
                About Me
              </Typography>
              <Typography variant="body1" paragraph>
                I'm Paulo Ouriques, a dedicated software engineer and problem
                solver. I'm a B.Sc. with M.Sc. degree in Computer Science at
                Federal University of Campina Grande. If you have an unsolved
                problem, share it with me and we will find the best
                computational solution.
              </Typography>
              <Grid2 container spacing={3} sx={{ mt: 4 }}>
                <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      display: "flex",
                      alignItems: "flex-start",
                      bgcolor: "transparent",
                    }}
                  >
                    <CodeIcon
                      sx={{ fontSize: 40, mr: 2, color: "primary.main" }}
                    />
                    <Box>
                      <Typography variant="h3" gutterBottom>
                        Programming
                      </Typography>
                      <Typography variant="body2">
                        Programming is challenging because it allows you to
                        solve the same problem in multiple ways.
                      </Typography>
                    </Box>
                  </Paper>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      display: "flex",
                      alignItems: "flex-start",
                      bgcolor: "transparent",
                    }}
                  >
                    <BookIcon
                      sx={{ fontSize: 40, mr: 2, color: "primary.main" }}
                    />
                    <Box>
                      <Typography variant="h3" gutterBottom>
                        Consulting
                      </Typography>
                      <Typography variant="body2">
                        The engineer ability of solving problems is useful in
                        many totally distinct contexts.
                      </Typography>
                    </Box>
                  </Paper>
                </Grid2>
              </Grid2>
            </Box>
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  );
};

export default About;
